<template>
  <div class="app-download">
    <!--    <img class="bg-img" :src="bgImg" />-->

    <img class="bg-img" src="../../../static/download/downloadappbg-1.jpg"/>

    <img class="bg-img" src="../../../static/download/downloadappbg-2.jpg"/>

    <!--    <img-->
    <!--      src="../../../static/download/androidButton.png"-->
    <!--      @click="downloadApp('android')"-->
    <!--      style="width: 189px; margin-top: 16px"-->
    <!--    />-->

    <!--      src="../../../static/download/iosButton.png"-->

    <div>
      <el-button
        class="el-button--primary el-button--large" type="primary"
        @click="downloadApp('android')"
        style="width: 280px; height: 60px; margin-top: 5px; background-color: red; color: white"
      >
        <img
          src="../../../static/download/android-icon.png"
          style="width: 40px; height: 40px; margin-right: 8px; vertical-align: middle"
        />
        安卓(Android)应用下载
      </el-button>
    </div>

    <div>
      <el-button
        class="el-button--primary el-button--large" type="primary"
        @click="downloadApp('ios')"
        style="width: 280px; height: 60px; margin-top: 5px; background-color: black; color: white">
        <img
          src="../../../static/download/ios-icon.png"
          style="width: 40px; height: 40px; margin-left: -60px; vertical-align: middle"
        />
        &nbsp;&nbsp;&nbsp;&nbsp;iOS应用下载
      </el-button>
    </div>

    <!--    <img-->
    <!--      src="../../../static/download/iosButton.png"-->
    <!--      @click="downloadApp('ios')"-->
    <!--      style="width: 189px; margin-top: 16px"-->
    <!--    />-->
    <!--    <img-->
    <!--      :src="androidButoon"-->
    <!--      @click="downloadApp('android')"-->
    <!--      style="width: 189px; margin-top: 16px"-->
    <!--    />-->

    <!--    <img-->
    <!--      :src="iosButoon"-->
    <!--      @click="downloadApp('ios')"-->
    <!--      style="width: 189px; margin-top: 16px"-->
    <!--    />-->

    <img
      v-show="isWechat" style="width: 100%; position: fixed; top: 0; left: 0; z-index: 9999"
      src="../../../static/app_download_remind.png"/>

  </div>
</template>

<script>
export default {
  data() {
    return {
      bgImg: "https://bopin.oss-cn-shenzhen.aliyuncs.com/adv/downloadappbg.png",
      iosButoon: "https://bopin.oss-cn-shenzhen.aliyuncs.com/adv/iosButton.png",
      androidButoon: "https://bopin.oss-cn-shenzhen.aliyuncs.com/adv/androidButton.png",
      isWechat: false, // 添加微信环境检测状态
    };
  },
  methods: {
    downloadApp(appType) {
      if (!appType) return;

      // 检测是否在微信中打开
      const isWechat = () => {
        const ua = navigator.userAgent.toLowerCase();
        return ua.includes('micromessenger');
      };

      // 如果在微信中打开，显示提示图片并返回
      if (isWechat()) {
        this.isWechat = true;
        return;
      }

      let downloadUrl;

      if (appType === "ios") {
        downloadUrl =
          "https://apps.apple.com/cn/app/%E6%92%AD%E8%81%98/id6449872334";
      } else {
        downloadUrl =
          "https://resource.abopin.com/app/176285441873051120332/file/176285441873051120332.apk";
          // "https://resource.abopin.com/app/1956557036112056322/file/175740406310459240739.apk";
      }

      const fileName = "播聘"; // 替换为实际的文件名

      // 创建 a 标签
      const a = document.createElement("a");
      a.style.display = "none";
      a.href = downloadUrl;
      a.setAttribute("download", fileName);

      // 将 a 标签添加到页面并触发点击事件
      document.body.appendChild(a);
      a.click();

      // 从页面中移除 a 标签
      document.body.removeChild(a);
    },
  },
};
</script>

<style>
.app-download {
  height: 100vh;
  width: 100%;
  text-align: center;
  background: linear-gradient(
    180deg,
    #f8604f 0%,
    #fff 45%,
    #fff 45%,
    #fff 100%
  );
}

.bg-img {
  width: 100%;
  max-width: 480px;
  margin: 0 auto;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/pages/app-download/index.vue